module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.sortedMonths), function(month) {
    return _c('div', {
      key: month.order,
      staticClass: "month-selector"
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "months_selector"
      },
      domProps: {
        "value": month.number,
        "checked": _vm.monthIsChecked(month)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelectedMonth(month)
        }
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(month.short))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b782f208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/ProductMonthSelector.vue
// module id = 576
// module chunks = 0